import { render, staticRenderFns } from "./ManageCrystalOrders.vue?vue&type=template&id=00787454&scoped=true&"
import script from "./ManageCrystalOrders.vue?vue&type=script&lang=ts&"
export * from "./ManageCrystalOrders.vue?vue&type=script&lang=ts&"
import style0 from "./ManageCrystalOrders.vue?vue&type=style&index=0&id=00787454&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00787454",
  null
  
)

export default component.exports